export default __webpack_public_path__ + "8dab2a6ba757bcc6e9a5c5f1026b3d40.svg";